import React from 'react';
import cn from 'classname';

const Row = ({
	row, intervals, can, expandedCountryIds, isHiddenCells, fetchExtendedOfferData, loadingAffiliateId,
	periodSwitch, isHiddenProfit
}) => {
	const dates = intervals || [];
	const datesNumber = dates ? dates.length : null;
	const isCountryRow = !!row.country_name;

	return (
		<tr className={cn({'top-affiliate-total-row': !isCountryRow })}>
			{
				isCountryRow &&
				<td className="fixed-col bald-font cursor-default first-affiliate-col">
					<p>{row.country_name}</p>
					<span
						className={cn({
							'hover-pointer': true,
							'dropdown-icon': true,
							'expand__icon': true,
							'rotating': loadingAffiliateId === row.country_id,
							'expand__icon--opened': expandedCountryIds.includes(row.country_id)
						})}
						onClick={fetchExtendedOfferData.bind(null, row.country_id)}
					/>
				</td>
			}
			{
				!isCountryRow && <td className="fixed-col bald-font first-affiliate-col" colSpan={1}>TOTAL</td>
			}
			<td className={cn({'top-affiliates-table-cell_description': true, 'display-none': isHiddenCells })}>
				<p className='flex-center'>
					<span className="width-50-p padding-0-5 text-right">
						{`${Math.round((row[`total_all_statuses`] || 0) / datesNumber)} `}
					</span>|
					<span className=" width-50-p padding-0-5 text-left light-green-text">
						{` ${Math.round((row[`total_approved`] || 0) / datesNumber)}`}
					</span>
				</p>
				<p className='flex-center'>
					<span className="width-50-p padding-0-5 text-right">
						{`${row[`total_all_statuses_approve_percent`] || 0} `}%
					</span>|
					<span className=" width-50-p padding-0-5 text-left light-green-text">
						{` ${row[`total_valid_approve_percent`] || 0}`}%
					</span>
				</p>
				{can('viewProfit') && !isHiddenProfit
					&& <p className='flex-center'>Profit {Math.round((row[`total_profit_usd`] || 0) / datesNumber)}$</p>
				}
			</td>
			{
				dates.map((item, key, arr) =>
					<ConversionsDateCell
						arr={arr} item={item} row={row} can={can} key={key} index={key} isHiddenCells={isHiddenCells}
						periodSwitch={periodSwitch} fetchExtendedOfferData={fetchExtendedOfferData} isHiddenProfit={isHiddenProfit}
					/>
				)
			}
			<td className={cn({'top-affiliates-table-cell_description': true, 'display-none': isHiddenCells })}>
				<p className='flex-center'>
					<span className="width-50-p padding-0-5 text-right">
						{`${row[`total_all_statuses`] || 0} `}
					</span>|
					<span className=" width-50-p padding-0-5 text-left light-green-text">
						{` ${row[`total_approved`] || 0}`}
					</span>
				</p>
				<p className='flex-center'>
					<span className="width-50-p padding-0-5 text-right">
						{`${row[`total_all_statuses_approve_percent`] || 0} `}%
					</span>|
					<span className=" width-50-p padding-0-5 text-left light-green-text">
						{` ${row[`total_valid_approve_percent`] || 0}`}%
					</span>
				</p>
				{can('viewAll') && <p className='flex-center'>Profit {Math.round(row[`total_profit_usd`]) || 0}$</p>}
			</td>
		</tr>
	);
};

const ConversionsDateCell = props => {
	const { item, arr, can, row, index, isHiddenCells, isHiddenProfit } = props;

	const isMoreThenBefore = !!arr[index + 1] &&
		Number(row[`${item}_all_statuses`]) > Number(row[`${arr[index + 1]}_all_statuses`]);

	const isLessThenBefore = !!arr[index + 1] &&
		Number(row[`${item}_all_statuses`]) < Number(row[`${arr[index + 1]}_all_statuses`]);

	return <td
		className={cn({'top-affiliates-table-cell_description': true, 'display-none': isHiddenCells })}
	>
		<p className='flex-center'>
			<span className="width-50-p padding-0-5 text-right">
				{`${row[`${item}_all_statuses`] || 0} `}
			</span>|
			<span className=" width-50-p padding-0-5 text-left light-green-text">
				{` ${row[`${item}_approved`] || 0}`}
				<span className={cn({ 'less': isLessThenBefore, 'more': isMoreThenBefore })}></span>
			</span>
		</p>
		<p className='flex-center'>
			<span className="width-50-p padding-0-5 text-right">
				{`${row[`${item}_all_statuses_approve_percent`] || 0} `}%
			</span>|
			<span className=" width-50-p padding-0-5 text-left light-green-text">
				{` ${row[`${item}_valid_approve_percent`] || 0}`}%
			</span>
		</p>
		{can('viewProfit') && !isHiddenProfit &&
			<p className="text-center">Profit {Math.round(row[`${item}_profit_usd`]) || 0}$</p>
		}
	</td>;
};

export default Row;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/top-countries/components/table/row.js